import { WrapperIconsTypeProps } from '../../Types';
import { MiniLoader } from '@app/shared';
import IconClear from './icons/close.svg';
import IconSuccess from './icons/success.svg';
import IconStar from './icons/star.svg';
import IconBlock from './icons/block.svg';

import styles from './FormField.module.scss';

export const Icons = ({ value, isBlock, isFocus, isValid, limit, isFetching, isRequired, handleClearField }: WrapperIconsTypeProps) => {
  const isIconClear = value && isFocus;
  const isIconSuccess = !isFocus && isValid;
  return (
    <div className={styles.Icons}>
      {isBlock && <IconBlock width={20} height={20} />}
      {isIconClear && <IconClear onClick={handleClearField} className={styles.Clear} width={20} height={20} />}
      {isIconSuccess && <IconSuccess className={styles.Success} width={14} />}
      {isRequired && value?.length === 0 && <IconStar width={12} height={12} />}
      {isFetching && <MiniLoader className={styles.Loader} />}
      {limit && <div className={styles.Limit}>{limit - (value?.length || 0)}</div>}
    </div>
  );
};
